import { SituacaoEnum } from '@/utils/enumerados';
import elementoVisivel from '../dom';

const SELECTOR_SITUACAO = '[data-tour="situacao"]';
const SELECTOR_INICIAR = '[data-tour="manifestacao-intencao-iniciar"]';
const SELECTOR_ENCERRAR = '[data-tour="manifestacao-intencao-encerrar"]';
const SELECTOR_RELOGIO = '[data-tour="manifestacao-intencao-relogio"]';
const SELECTOR_CHAT = '[data-tour="manifestacao-intencao-chat"]';
const SELECTOR_BOTAO = '[data-tour="manifestacao-intencao-botao"]';
const SELECTOR_CHAT_HEADER = '.chat-header';
const SELECTOR_CHAT_CONTENT = '.chat-content';
const CHAT_ATIVA_CLASS = 'chat-ativo';

function expandChatIfNeeded() {
  const content = document.querySelector(SELECTOR_CHAT_CONTENT);
  if (content && !content.classList.contains(CHAT_ATIVA_CLASS)) {
    document.querySelector(SELECTOR_CHAT_HEADER)?.click();
  }
}

export default {
  id: 'manifestacao-intencao-recurso',
  kind: 'tour',
  version: 1,
  label: 'Manifestação de Intenção de Recurso',
  contexts: ['auction.situation'],
  situation: SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO,
  priority: 10,
  help: true,
  canStart(ctx = {}) {
    if (!ctx.logged) return false;
    if (Number(ctx.situation) !== SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO) return false;
    return Boolean(
      elementoVisivel(SELECTOR_SITUACAO) ||
        elementoVisivel(SELECTOR_INICIAR) ||
        elementoVisivel(SELECTOR_ENCERRAR) ||
        elementoVisivel(SELECTOR_CHAT),
    );
  },
  steps(ctx = {}) {
    const steps = [
      {
        element: SELECTOR_SITUACAO,
        popover: {
          title: 'Manifestação de Intenção de Recurso',
          description: ctx.isCrier
            ? 'Nesta etapa os licitantes registram se pretendem recorrer, antes da Interposição de Recursos. Você controla o relógio e o encerramento da fase.'
            : 'Nesta etapa você registra se pretende recorrer. Somente quem manifestar a intenção poderá apresentar recurso na etapa seguinte.',
          side: 'bottom',
          align: 'center',
        },
      },
    ];

    if (elementoVisivel(SELECTOR_INICIAR)) {
      const jaHouveRelogio = Boolean(elementoVisivel(SELECTOR_ENCERRAR));
      steps.push({
        element: SELECTOR_INICIAR,
        popover: {
          title: 'Iniciar Manifestação',
          description: jaHouveRelogio
            ? 'O relógio anterior encerrou. Use este botão para iniciar um novo prazo; enquanto vigente, os licitantes poderão manifestar intenção de recurso.'
            : 'Use este botão para iniciar o relógio da manifestação. Enquanto o prazo estiver vigente, os licitantes poderão manifestar intenção de recurso.',
          side: 'bottom',
          align: 'center',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ENCERRAR)) {
      steps.push({
        element: SELECTOR_ENCERRAR,
        popover: {
          title: 'Encerrar Manifestação',
          description:
            'Quando o relógio não estiver vigente, use este botão para encerrar a etapa e avançar para a Interposição de Recursos. Os licitantes não poderão mais manifestar intenção.',
          side: 'bottom',
          align: 'center',
        },
      });
    }

    if (ctx.prazoManifestacaoVigente && elementoVisivel(SELECTOR_RELOGIO)) {
      steps.push({
        element: SELECTOR_RELOGIO,
        popover: {
          title: 'Relógio da manifestação',
          description:
            'Este relógio é o prazo da manifestação. Enquanto estiver vigente, os licitantes podem registrar a intenção de recurso.',
          side: 'bottom',
          align: 'center',
        },
      });
    }

    if (elementoVisivel(SELECTOR_CHAT)) {
      const podeMostrarBotao = Boolean(ctx.isBidder && ctx.prazoManifestacaoVigente);
      let descricaoChat =
        'Quando o pregoeiro iniciar o relógio, o botão para manifestar intenção de recurso aparece no chat da sessão.';
      if (ctx.isCrier) {
        descricaoChat =
          'Os licitantes manifestam a intenção de recurso pelo botão no chat da sessão, enquanto o relógio estiver vigente.';
      } else if (ctx.prazoManifestacaoVigente) {
        descricaoChat =
          'No chat da sessão você registra a intenção de recurso, enquanto o relógio estiver vigente.';
      }

      const chatStep = {
        element: SELECTOR_CHAT,
        popover: {
          title: 'Chat da sessão',
          description: descricaoChat,
          side: 'left',
          align: 'start',
        },
      };

      if (podeMostrarBotao) {
        chatStep.popover.onNextClick = (element, step, { driver }) => {
          expandChatIfNeeded();
          driver.moveNext();
          setTimeout(() => driver.refresh(), 320);
        };
      }

      steps.push(chatStep);

      if (podeMostrarBotao) {
        steps.push({
          element: SELECTOR_BOTAO,
          waitForElement: 1000,
          popover: {
            title: ctx.hasAppealIntention
              ? 'Intenção registrada'
              : 'Manifestar intenção de recurso',
            description: ctx.hasAppealIntention
              ? 'Sua intenção de recurso já está registrada. Somente quem manifestou poderá apresentar recurso na Interposição de Recursos.'
              : 'Use este botão para registrar a intenção de recurso. A manifestação habilita o envio de recurso na etapa seguinte.',
            side: 'bottom',
            align: 'end',
          },
        });
      }
    }

    return steps;
  },
};
